import { Link, StaticQuery, graphql } from 'gatsby'

import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'
import ArBlogAuthor from 'src/components/blog/ArBlogAuthor/ArBlogAuthor'
// ArComponents
import ArMonoTag from 'src/components/typography/ArMonoTag'
import ArParagraph from 'src/components/typography/ArParagraph'
import React from 'react'
import { media } from 'src/styles/styled-components'
import styled from 'styled-components'

const StyledContainer = styled.article`
  background-color: ${ ({ theme }) => theme.colors.white };
  display: flex;
  flex-direction: row;
  margin-top: -100px;
  min-height: 300px;
  width: 100%;
  ${ media.desktop`
    /* max-height: 500px; */
  ` }
`

const StyledImage = styled(ArBaseImage)`
  width: 50%;

  img {
    height: auto;
  }

  ${ media.desktop`
    margin-top: -1px;
  ` }
`

const StyledPostContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  width: 50%;
  ${ media.desktop`
    padding: 40px;
  ` }
`

const StyledTitle = styled.h2`
  font-size: 2.6rem;
  line-height: 1.19;
  margin-bottom: 10px;
  ${ media.desktop`
    font-size: 4.5rem;
    font-weight: ${ p => p.theme.fontWeight.primary.Light };
    line-height: 1.4;
  ` }
`

const StyledDescription = styled(ArParagraph)`
  margin-bottom: 20px;
  max-width: 80%;
  text-align: justify;
`

const StyledAuthors = styled.div`
  display: flex;
  flex-direction: column;
  ${ media.tablet`
    flex-direction: row;
    @media (orientation: portrait) {
      flex-direction: column;
      & > div:not(:last-of-type) {
        margin-bottom: 10px;
      }
    }
  ` }
  & > div:not(:last-of-type) {
    margin-right: 20px;
  }
`

class ArBlogPromoPost extends React.Component {
  post = {}

  componentWillMount () {
    const data = this.props.data ? this.props.data.allContentfulPost.edges[0].node : null
    if (!data) return
    this.post = {
      title: data.title.title,
      description: data.description.description,
      author: {
        name: data.author[0].name,
        image: data.author[0].profilePhoto.file.url,
      },
      category: data.category[0].title,
    }
  }

  getPostData (post) {
    const data = post.allContentfulPost.edges[0].node
    const featuredImage = data.featuredImage || {}
    return {
      slug: data.slug,
      title: data.title.title,
      description: data.description.description,
      author: Array.isArray(data.author) ? data.author.map(author => ({
        name: author.name || 'no author',
        image: author?.profilePhoto?.file?.url || '',
      })) : [{
        name: data.author ? data.author[0].name : 'no author',
        image: data.author ? data.author[0].profilePhoto ? data.author[0].profilePhoto.file.url : '' : '',
      }],
      image: {
        title: featuredImage.title,
        url: (featuredImage.file || {}).url,
      },
      category: data.category[0].title,
    }
  }

  renderPropoPost (data) {
    const post = this.getPostData(data)
    return (
      <Link to={`/company/blog/${ post.slug }`}>
        <StyledContainer>
          <StyledImage src={post.image.url} alt={post.image.title} />
          <StyledPostContent>
            <div>
              <ArMonoTag>{post.category}</ArMonoTag>
              <StyledTitle>{post.title}</StyledTitle>
              <StyledDescription>{post.description}</StyledDescription>
            </div>
            <StyledAuthors>
              {post.author.map(author => <ArBlogAuthor key={author.name} author={author} small />)}
            </StyledAuthors>
          </StyledPostContent>
        </StyledContainer>
      </Link>
    )
  }

  render () {
    return (
      <StaticQuery
        query={query}
        render={this.renderPropoPost.bind(this)}
      />
    )
  }
}

const query = graphql`
query BlogPromoPost {
  allContentfulPost(
    limit: 1,
    filter:{
      promoted: {
        eq: true
      }
    },
    sort: {
      fields: [createdAt]
      order: DESC
    }
  ) {
    edges {
      node {
        id
        slug
        title {
          title
        }
        description {
          description
        }
        featuredImage {
          file {
            url
          }
          title
        }
        author{
          name
          profilePhoto {
            file {
              url
            }
          }
        }
        category {
          title
        }
      }
    }
  }
}
`

export default ArBlogPromoPost
